"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RGB_Linear_Shade = exports.RGB_Linear_Blend = void 0;

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var round_to = function round_to(n, precision) {
  return Math.round(n * Math.pow(10, precision)) / Math.pow(10, precision);
};

var unwrap_arr = function unwrap_arr(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};

var sleep = function sleep() {
  var ms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
  return new Promise(function (res) {
    return setTimeout(res, ms);
  });
};

var scale = function scale(num, in_min, in_max, out_min, out_max) {
  return (num - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
};

var calc_min = function calc_min(arr) {
  return arr.map(function (x) {
    return x.value;
  }).reduce(function (previous, current) {
    return previous < current ? previous : current;
  });
};

var calc_max = function calc_max(arr) {
  return arr.map(function (x) {
    return x.value;
  }).reduce(function (previous, current) {
    return previous > current ? previous : current;
  });
};

var calc_item_height = function calc_item_height(v, min, max, chart_height, topSpace) {
  return round_to(scale(v, min, max, 0, v < topSpace ? chart_height : chart_height - topSpace), 0);
};

var calc_item_width = function calc_item_width(chart_width, chunk) {
  return round_to(chart_width / chunk, 0);
};

var calc_color = function calc_color(shades, i) {
  return Array.isArray(shades) ? RGB_Linear_Blend(i / 10, shades[0], shades[1]) : RGB_Linear_Shade(i * 16 / 100, shades);
};

var RGB_Linear_Blend = function RGB_Linear_Blend(p, c0, c1) {
  var i = parseInt,
      r = Math.round,
      P = 1 - p,
      _c0$split = c0.split(','),
      _c0$split2 = _slicedToArray(_c0$split, 4),
      a = _c0$split2[0],
      b = _c0$split2[1],
      c = _c0$split2[2],
      d = _c0$split2[3],
      _c1$split = c1.split(','),
      _c1$split2 = _slicedToArray(_c1$split, 4),
      e = _c1$split2[0],
      f = _c1$split2[1],
      g = _c1$split2[2],
      h = _c1$split2[3],
      x = d || h,
      d = x ? ',' + (!d ? h : !h ? d : r((parseFloat(d) * P + parseFloat(h) * p) * 1000) / 1000 + ')') : ')';

  return 'rgb' + (x ? 'a(' : '(') + r(i(a[3] == 'a' ? a.slice(5) : a.slice(4)) * P + i(e[3] == 'a' ? e.slice(5) : e.slice(4)) * p) + ',' + r(i(b) * P + i(f) * p) + ',' + r(i(c) * P + i(g) * p) + d;
};

exports.RGB_Linear_Blend = RGB_Linear_Blend;

var RGB_Linear_Shade = function RGB_Linear_Shade(p, c) {
  var i = parseInt,
      r = Math.round,
      _c$split = c.split(','),
      _c$split2 = _slicedToArray(_c$split, 4),
      a = _c$split2[0],
      b = _c$split2[1],
      c = _c$split2[2],
      d = _c$split2[3],
      P = p < 0,
      t = P ? 0 : 255 * p,
      P = P ? 1 + p : 1 - p;

  return 'rgb' + (d ? 'a(' : '(') + r(i(a[3] == 'a' ? a.slice(5) : a.slice(4)) * P + t) + ',' + r(i(b) * P + t) + ',' + r(i(c) * P + t) + (d ? ',' + d : ')');
};

exports.RGB_Linear_Shade = RGB_Linear_Shade;
var _default = {
  calc_color: calc_color,
  calc_item_height: calc_item_height,
  calc_item_width: calc_item_width,
  calc_min: calc_min,
  calc_max: calc_max,
  scale: scale
};
exports["default"] = _default;